import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { uniqueId, uniqBy } from 'lodash';
import { convertMoney } from '@/utils/convertMoney';
import { styled } from '@mui/system';
import { style } from '@/styles/globals';
import FlexTableRow from '@/components/FlexTableRow';
import WideTableCell from '@/components/WideTableCell';
import { format } from 'date-fns';
import RedirectAlert from '../RedirectAlert';
import { useBoolean } from '@/utils/hooks';
import { useState } from 'react';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { ReserveButton } from './ReserveButton';

const getDataInSomeDate = (days: any) => {
  const sortedDays = days
    .filter((item: any) => !!item?.averageMinfare)
    .sort((a: any, b: any) => a?.averageMinfare - b?.averageMinfare);

  return uniqBy(sortedDays, (e: any) => e.airline.name);
};

const CTABooking = styled('div')`
  ${style.text.content.bold}
  text-align: center;
  color: ${style.color.product3};
  cursor:pointer;
`;

export default function FareByAirlineInMonthVcms({
  days, onSelectTrip, isDesktop, lang,
}: { days: any, onSelectTrip: any, isDesktop: any, lang?: ILangObj }) {
  const TableHeader = [lang?.AirlineFareTable?.airline || 'Hãng hàng không', lang?.AirlineFareTable?.cheapestPrice || 'Giá vé rẻ nhất', lang?.AirlineFareTable?.cheapestPrice30 || 'Ngày rẻ nhất 30 ngày tới'];

  const data = getDataInSomeDate(days);
  const [open, setOpen] = useBoolean(false);
  const [param, setParam] = useState<any>({});
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
    >
      <Table
        sx={{ }}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{
            background: 'white',
            border: 0,
          }}
          >
            {TableHeader.map((label: string) => (
              <WideTableCell
                key={label}
                align="center"
              >
                {label}
              </WideTableCell>
            ))}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {(data || []).map((row: any) => (
            <FlexTableRow
              key={uniqueId()}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <WideTableCell align="center">{row?.airline?.name || 'Đang cập nhật'}</WideTableCell>
              <WideTableCell
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                {row?.averageMinfare ? convertMoney(row?.averageMinfare).replace('đ', (lang?.global?.VND || 'đ')) : (lang?.global.updating || 'Đang cập nhật')}
              </WideTableCell>
              <WideTableCell align="center">
                <div>
                  {format(new Date(row.date), 'dd/MM/yyyy')}
                </div>
                <ReserveButton
                  onClick={() => onSelectTrip(row)}
                  lang={lang}
                />
              </WideTableCell>
            </FlexTableRow>
          ))}
        </TableBody>
      </Table>
      <RedirectAlert
        open={open}
        setOpen={setOpen}
        params={param}
        onConfirm={onSelectTrip}
      />
    </TableContainer>
  );
}
